<template>
  <div>
    <div class="cart-body">

      <div ref="result"></div>
      <div v-if="checkout_step === 5">
        <thank-you v-if="sale_id" :mail="email.split('@')[1]" :sale_id="sale_id" />
      </div>
      <div  v-else class="cart-cont">
        <div class="cart-col">
          <div class="cart-logo"><a href="https://www.authorizelocal.com">
            <img src="/autohrizeLocalLogo.png"></a></div>
          <div class="checkout-steps">
            <div class="chk-step" @click="checkout_step = 1" :class="checkout_step > 0 ? 'completed' : ''">
              <div class="chk-step-number">1</div>
              <div class="chk-step-bar"></div>
            </div>
            <div class="chk-step" @click="max_step >= 2 ? checkout_step = 2 : null" :class="checkout_step > 1 ? 'completed' : ''">
              <div class="chk-step-number">2</div>
              <div class="chk-step-bar"></div>
            </div>
            <div class="chk-step" @click="max_step >= 3 ? checkout_step = 3 : null" :class="checkout_step > 2 ? 'completed' : ''">
              <div class="chk-step-number">3</div>
              <div class="chk-step-bar"></div>
            </div>
            <div class="chk-step" @click="max_step >= 4 ? checkout_step = 4 : null" :class="checkout_step > 3 ? 'completed' : ''">
              <div class="chk-step-number">4</div>
            </div>
<!--            <div class="chk-step" @click="max_step >= 5 ? checkout_step = 5 : null" :class="checkout_step > 4 ? 'completed' : ''">
              <div class="chk-step-number">5</div>
              <div class="chk-step-name">Payment</div>
            </div>-->
          </div>
          <div class="cart-form" v-if="!loading">
            <div v-if="checkout_step === 1">
              <div class="cart-form-row">
                <div class="cart-form-label">First Name</div>
                <div class="cart-form-input">
                  <input required class="cart-input"
                         type="text" placeholder="Enter your first name..."
                         ref="First Name"
                         name="First Name"
                         v-model="name"
                         data-vv-name="First Name"
                         v-validate="'required'">

                  <span class="text-danger text-sm" v-show="errors.has('First Name')">{{
                      errors.first('First Name')
                    }}</span>
                </div>
              </div>
              <div class="cart-form-row">
                <div class="cart-form-label">Last Name</div>
                <div class="cart-form-input">
                  <input required class="cart-input"
                         type="text" placeholder="Enter your last name..."
                         ref="Last Name"
                         name="Last Name"
                         v-model="lastname"
                         data-vv-name="Last Name"
                         v-validate="'required'">

                  <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{
                      errors.first('Last Name')
                    }}</span>
                </div>
              </div>
              <div class="cart-form-row">
                <div class="cart-form-label">Email Address</div>
                <div class="cart-form-input">
                  <input required class="cart-input"
                         type="email"
                         placeholder="Enter your email address..."
                         ref="Email"
                         name="Email"
                         v-model="email"
                         data-vv-name="Email"
                         v-validate="'required'">

                  <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
                </div>
              </div>
              <div class="cart-form-row">
                <div class="cart-form-label">Phone Number</div>
                <div class="cart-form-input">
                  <phone-mask-input
                    v-model="phone"
                    autoDetectCountry
                    showFlag
                    @onValidate="onValidate"
                    wrapperClass="relative"
                    inputClass="cart-input"
                    flagClass="phone-flag"
                  />

                  <span class="text-danger text-sm" v-show="errors.has('Phone')">{{ errors.first('Phone') }}</span>
                </div>
              </div>
              <div class="cart-form-row">
                <div class="cart-form-label">Company Name</div>
                <div class="cart-form-input">
                  <input class="cart-input"
                         type="text" placeholder="Enter your company name..."
                         ref="Company Name"
                         name="Company Name"
                         v-model="company_name"
                         data-vv-name="Company Name">

                  <span class="text-danger text-sm" v-show="errors.has('Company Name')">{{
                      errors.first('Company Name')
                    }}</span>
                </div>
              </div>
            </div>
            <div v-if="checkout_step === 2">
              <div class="w-full">
                <div class="flex flex-col verify">
                  <div class="cart-form-row">
                    <div class="cart-form-label">We've sent you an SMS</div>
                    <div class="cart-form-input" v-if="!sms_verified">
                      <input required class="cart-input"
                             style="text-transform: uppercase"
                             type="text" placeholder="Enter 6-digit code"
                             ref="Code"
                             name="Code"
                             maxlength="6"
                             v-model="sms_code"
                             data-vv-name="Verification Code"
                             v-validate="'required'">
                      <span class="text-danger text-sm" v-show="errors.has('Code')">{{
                          errors.first('Code')
                        }}</span>
                      <div class="resend-code" @click="checkMail">Resend Code</div>
                    </div>
                    <div v-else>
                      verified
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="checkout_step === 3">
              <div class="cart-form-row">
                <div class="cart-form-label">Billing Address</div>
                <div class="cart-form-input">
                  <places :location="street" :found="placesFoundBilling" classes="w-full cart-input"></places>


                  <span class="text-danger text-sm" v-show="errors.has('Street')">{{ errors.first('Street') }}</span>
                </div>
                <div class="cart-form-input">
                  <input class="cart-input"
                         type="text" placeholder="Unit, Apartment # etc."
                         ref="Unit"
                         name="Unit"
                         v-model="unit"
                         data-vv-name="Unit">

                  <span class="text-danger text-sm" v-show="errors.has('Unit')">{{ errors.first('Unit') }}</span>
                </div>
                <div class="cart-form-input cart-flex-row">
                  <div class="cart-flex-item">
                    <input class="cart-input" type="text" placeholder="City"
                           ref="City"
                           name="City"
                           v-model="city"
                           data-vv-name="City"
                           v-validate="'required'">

                    <span class="text-danger text-sm" v-show="errors.has('City')">{{ errors.first('City') }}</span>
                  </div>
                  <div class="cart-flex-item">
                    <input class="cart-input" type="text" placeholder="State"
                           ref="State"
                           name="State"
                           v-model="state"
                           data-vv-name="State"
                           v-validate="'required'">

                    <span class="text-danger text-sm" v-show="errors.has('State')">{{ errors.first('State') }}</span>
                  </div>
                  <div class="cart-flex-item">
                    <input class="cart-input" type="text" placeholder="ZIP Code"
                           ref="Zip Code"
                           name="Zip Code"
                           v-model="zipcode"
                           data-vv-name="Zip Code"
                           v-validate="'required'">

                    <span class="text-danger text-sm" v-show="errors.has('Zip Code')">{{
                        errors.first('Zip Code')
                      }}</span>
                  </div>

                </div>
              </div>
            </div>
<!--            <div v-if="checkout_step === 5">
              <div class="cart-form-row">
                <div class="cart-form-label">Payment Information</div>
                <div class="cart-form-input">
                  <stripe-vue-card ref="paymentBridge" :seti="seti" :pi_secret="pi_secret" :info="{payAmount: total_price}"
                                   v-if="pi_secret"/>
                </div>

                <div class="complete-payment" @click="submitPayment">Complete Payment</div>
                <div class="stripe-badge"><img alt="Guaranteed safe & secure checkout with Stripe"
                                               src="../../../assets/images/stripe-badge-white.png"/></div>
              </div>
            </div>-->
            <div class="cart-sum" v-if="product && checkout_step === 4">
              <div class="cart-form-label">Your Services</div>
              <div class="cart-form-row cart-flex-row"
                   v-if="product.serviceList.length > 0"
                   v-for="service in product.serviceList"
                   :key="service._id">
                <div class="cart-flex-item cart-item-icon">
                  <i class="fas fa-check-circle"></i>
                </div>
                <div class="cart-flex-item cart-item-name">
                  <h3>Free {{ service.name }}</h3>
                  <p>{{ service.description }}</p>
                </div>
                <div class="cart-flex-item cart-item-icon">
                  <i class="fas fa-sticky-note"></i>
                </div>
                <div class="cart-flex-item cart-item-name">
                  <span>Free trail will end {{lastSevenDay}}; then the amount below is applicable. A subscription will be requested with a credit card after 7 days</span>
                </div>
              </div>
              <div class="cart-total-cont">
                <div class="sub cart-form-row cart-flex-row">
                  <div class="cart-flex-item">Sub Total:</div>
                  <div class="cart-flex-item">${{ (total_price - (total_price * 0.0875)).toFixed(2) }}</div>
                </div>
                <div class="sub cart-form-row cart-flex-row">
                  <div class="cart-flex-item">Tax:</div>
                  <div class="cart-flex-item">${{ (total_price * 0.0875).toFixed(2) }} </div>  <!--total_price * 0.0875).toFixed(2)-->
                </div>
                <div class="cart-form-row cart-flex-row cart-total">
                  <div class="cart-flex-item">TOTAL:</div>
                  <div class="cart-flex-item">${{ total_price }}/{{ product_freq }}</div>
                </div>
              </div>
              <div class="complete-payment" @click="submitPayment">Complete Registaration</div>
            </div>

            <div class="continue-button al-button" v-if="checkout_step !== 4" @click="submitPayment">Save & Continue</div>
          </div>
          <div class="cart-loading" v-else>
            <div class="loading">
              <div class="effect-1 effects"></div>
              <div class="effect-2 effects"></div>
              <div class="effect-3 effects"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <the-footer/>
  </div>
</template>
<script>
import TheFooter from '@/layouts/components/TheFooter.vue'
import StripeVueCard from '../../../components/stripe/StripeVueCard'
import PhoneMaskInput from  'vue-phone-mask-input'
import Places from '../../../components/places/Places'
import ThankYou from './components/ThankYou'
import moment from 'moment'

export default {
  props: {
    slug: {
      type: String
    }
  },
  // sayfa vue tarafından açılana kadar index.html deki title description'ı okuyor
  // nasıl düzelir hiç bi fikrim yok
  // sayfa açıldığı an urldeki uzantıdan okuyup parçalayıp titlea basıyorum
  // ssr olmadan olmaz gibi bu
  metaInfo () {
    return {
      title: `Cart - ${this.meta_title}`,
      titleTemplate: '%s - AuthorizeLocal',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Review your products'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Local SEO Solutions'
        }
      ]
    }
  },
  components: {
    ThankYou,
    TheFooter,
    PhoneMaskInput,
    StripeVueCard,
    Places,
    moment
  },
  watch: {
    loading () {
      if (this.loading) {
        setTimeout(() => {
          this.loading = false
        }, 500)
      }
    }
  },
  computed: {
    meta_title () {
      let res = ''
      if (this.slug.includes('-')) {
        this.slug.split('-').map(word => {
          let wordie = word.substr(0, 1).toUpperCase()
          wordie += word.substr(1).toLowerCase()
          wordie += ' '
          res += wordie
        })
      }
      return res
    },
    lastSevenDay () {
      return moment().add(7, 'days').format('MM/DD/YYYY')
    },
    total_price () {
      return this.product.price.toFixed(2) // + (this.product.price * 0.0875)).toFixed(2)
    },
    product_freq () {
      if (this.product.freq.includes('ily')) {
        const result = this.product.freq.replace('ily', 'y')
        return `${result.substring(0, 1).toUpperCase()}${result.substring(1)}`
      } else if (this.product.freq.includes('ly')) {
        const result = this.product.freq.replace('ly', '')
        return `${result.substring(0, 1).toUpperCase()}${result.substring(1)}`
      } else {
        return this.product.freq
      }
    },
    products_price () {
      let total = 0
      this.product.serviceList.map(service => {
        total += service.price
      })
      return total.toFixed(2)
    }
  },
  data () {
    return {
      loading: false,
      sms_verified: false,
      checkout_step: 1,
      sale_id: 3,
      max_step: 1,
      pi_secret: null,
      seti: null,
      subscription_id: null,
      product: null,
      full_name: '',
      name: '',
      sms_code: '',
      lastname: '',
      email: '',
      phone: '',
      company_name: '',
      street: '',
      city: '',
      unit: '',
      zipcode: '',
      state: '',
      stripe_customer: null,
      user_saved: false,
      user: null,
      payment_success: false,
      placeService: null
    }
  },
  mounted () {
    this.placeService = new window.google.maps.places.PlacesService(this.$refs.result)
    if (this.slug) {
      console.log('slug', this.slug)
      this.getBundle()
    }
  },
  methods: {

    placesFoundBilling (value, deliver_to) {
      console.log('selected value', value, deliver_to)
      this.street = deliver_to
      this.state = value.terms[3].value
      this.city = value.terms[2].value

      const self = this
      this.getPlaceDetails(value.place_id, (PlaceResult) => {
        self.zipcode = PlaceResult.address_components.filter(comp => comp.types.includes('postal_code'))[0].long_name
      })
    },
    save_n_continue () {
      this.loading = true

      this.checkout_step += 1
      this.max_step = this.checkout_step
    },
    onValidate (data) {
      console.log(data)
    },
    setPrices (product) {
      try {
        product.price = product.price / 100
        product.serviceList.map(service => {
          service.price = service.price / 100
        })
        return product
      } catch (e) {
        console.log('set price error', e)
      }
    },
    checkMail () {
      const mail_payload = {
        email: this.email,
        phone: this.phone
      }
      this.loading = true
      this.$store.dispatch('checkMail', mail_payload)
        .then(result => {
          if (result) {
            this.$vs.loading.close()
          }
        })
    },
    submitPayment () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const address = {
            street: this.street,
            unit: this.unit,
            zipcode: this.zipcode,
            state: this.state,
            city: this.city
          }
          const user = {
            name: this.name,
            lastname: this.lastname,
            email: this.email,
            phone: this.phone,
            company: {
              name: this.company_name,
              billing_address: address,
              address
            },
            bundle_slug: this.slug
          }
          if (this.stripe_customer) {
            user.stripe_customer = this.stripe_customer
          }
          if (this.checkout_step === 1) {
            const mail_payload = {
              email: this.email,
              phone: this.phone
            }
            this.loading = true
            this.$store.dispatch('checkMail', mail_payload)
              .then(result => {
                if (result) {
                  console.log('registerUserCart', result)
                  this.save_n_continue()
                }
              })
              .catch(error => {
                console.log(error)
                this.$vs.notify({
                  title: 'Error',
                  text: 'Email already exists',
                  color: 'warning',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
                })

                this.$vs.loading.close()
              })
          } else if (this.checkout_step === 2) {
            console.log('verify')
            const sms_payload = {
              phone: this.phone,
              code: this.sms_code
            }

            this.$store.dispatch('verifyPhone', sms_payload)
              .then(result => {
                if (result) {
                  console.log('verify sms', result)
                  this.sms_verified = true
                  this.save_n_continue()
                }
              })
              .catch(error => {
                console.log(error)
                this.$vs.notify({
                  title: 'Error',
                  text: 'Verification failed',
                  color: 'warning',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
                })

                this.$vs.loading.close()
              })
          } else if (this.checkout_step === 3) {
            this.$vs.loading()
            this.getPaymentIntent(user)
          } else if (this.checkout_step === 4) {
            this.payment_success = true
            this.$store.dispatch('registerUserCart', user)
              .then(result => {
                if (result) {
                  this.user_saved = true
                  this.user = result.data.data
                  console.log('registerUserCart', result)

                  //this.saveCard(stripe_result)
                  this.saveSale(this.user._id, this.product._id)
                  this.$vs.notify({
                    title: 'Success',
                    text: result.data.message,
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check'
                  })

                }
              })
              .catch(error => {
                console.log(error)
                this.checkout_step = 1
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Error',
                  text: 'Email already exists',
                  color: 'warning',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
                })

                this.$vs.loading.close()
              })
          } /*else if (this.checkout_step === 5) {
            this.$vs.loading()
            if (this.slug.includes('scratch')) {
              this.$refs.paymentBridge.setup((response) => {
                console.log('stripe token and amount', response)
                if (response.error) {
                  this.$vs.loading.close()
                  console.log('failed payment')
                } else {
                  const stripe_result = response.setupIntent
                  if (stripe_result.status === 'succeeded') {
                    this.payment_success = true
                    this.$store.dispatch('registerUserCart', user)
                      .then(result => {
                        if (result) {
                          this.user_saved = true
                          this.user = result.data.data
                          console.log('registerUserCart', result)

                          this.saveCard(stripe_result)
                          this.saveSale(this.user._id, this.product._id)
                          this.$vs.notify({
                            title: 'Success',
                            text: result.data.message,
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check'
                          })

                        }
                      })
                      .catch(error => {
                        console.log(error)
                        this.checkout_step = 1
                        this.$vs.loading.close()
                        this.$vs.notify({
                          title: 'Error',
                          text: 'Email already exists',
                          color: 'warning',
                          iconPack: 'feather',
                          icon: 'icon-alert-circle'
                        })

                        this.$vs.loading.close()
                      })
                  } else {
                    this.$vs.notify({
                      title: 'Failed',
                      text: 'Payment Failed',
                      color: 'warning',
                      iconPack: 'feather',
                      icon: 'icon-alert'
                    })

                    this.$vs.loading.close()
                    console.log('failed payment')
                  }
                }
              })
            } else {
              this.$refs.paymentBridge.purchase((response) => {
                console.log('stripe token and amount', response, user, this.stripe_customer)
                if (response.error) {
                  this.$vs.loading.close()
                  console.log('failed payment')
                } else {
                  const stripe_result = response.paymentIntent
                  if (stripe_result.status === 'succeeded') {
                    this.payment_success = true
                    this.$vs.notify({
                      title: 'Success',
                      text: 'Payment Successful',
                      color: 'success',
                      iconPack: 'feather',
                      icon: 'icon-check'
                    })
                    console.log('success payment')

                    this.$store.dispatch('registerUserCart', user)
                      .then(result => {
                        if (result) {
                          this.user_saved = true
                          this.user = result.data.data
                          console.log('registerUserCart', result)

                          this.saveCard(stripe_result)
                          this.saveSale(this.user._id, this.product._id)
                          this.$vs.notify({
                            title: 'Success',
                            text: result.data.message,
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check'
                          })

                        }
                      })
                      .catch(error => {
                        console.log(error)
                        this.checkout_step = 1
                        this.$vs.loading.close()
                        this.$vs.notify({
                          title: 'Error',
                          text: 'Email already exists',
                          color: 'warning',
                          iconPack: 'feather',
                          icon: 'icon-alert-circle'
                        })

                        this.$vs.loading.close()
                      })
                  } else {
                    this.loading = true
                    this.$vs.notify({
                      title: 'Failed',
                      text: 'Payment Failed',
                      color: 'warning',
                      iconPack: 'feather',
                      icon: 'icon-alert'
                    })

                    this.$vs.loading.close()
                    console.log('failed payment')
                  }
                }
              })
            }
          }*/

        }
      })
    },

    getPlaceDetails (place_id, callback) {

      const self = this
      this.placeService.getDetails({placeId: place_id}, function (PlaceResult, PlacesServiceStatus) {
        // PlaceResult is an object
        // PlacesServiceStatus is a string
        self.selectedPlace = PlaceResult
        console.log('places service status', PlacesServiceStatus)
        callback(PlaceResult)
      })
    },
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Payment Confirmed',
        text: 'You will receive an email to set your password. Please check your inbox for details.',
        acceptText: 'Home Page',
        cancelText: 'Portal Page',
        accept,
        cancel
      })
    },
    saveSale (customer, bundle) {
      const sale = {
        price: parseFloat(this.total_price),
        customer,
        bundle,
        subscription_id: this.subscription_id
      }

      this.$store.dispatch('saveSale', sale)
        .then(response => {
          console.log('saveSale', response)
          this.$vs.loading.close()

          this.sale_id = response.data.data.sale_id

          this.checkout_step = 5

          /*this.openConfirm(() => {
            this.$validator.validateAll().then(result => {
              if (result) {
                window.location.replace('https://authorizelocal.com')
                //test
              }
            })
          }, () => {
            window.location.replace('https://portal.authorizelocal.com/login')
          })
*/
        })
        .catch(e => {
          console.log(e)
        })
    },
    saveCard (stripe_result) {
      const payload = {
        payment_method: stripe_result.payment_method,
        is_default: true,
        user_id: this.user._id
      }
      this.$store.dispatch('saveCardForUser', payload)
        .then((response) => {
          console.log('success save_card', response)
          this.$vs.loading.close()
        })
        .catch((e) => {
          console.log(e)
          this.$vs.notify({
            title: 'Failed',
            text: 'Save Card Failed',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert'
          })

          this.$vs.loading.close()
        })
    },
    getBundle () {
      this.$store.dispatch('getBundleSlug', this.slug)
        .then(response => {
          console.log('bundleslug', response)
          this.product = this.setPrices(response.data.data)
        })
        .catch(e => {
          console.log(e)
        })
    },
    getPaymentIntent (user) {
      const payload = {
        bundle_id: this.product._id,
        user
      }
      this.$store.dispatch('saveSaleMakePayment', payload)
        .then((response) => {
          console.log('pi', response)
          this.pi_secret = response.data.clientSecret
          this.seti = response.data.seti
          this.subscription_id = response.data.subscriptionId
          this.stripe_customer = response.data.stripe_customer
          this.save_n_continue()
          this.$vs.loading.close()
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
        })

    }
  }
}
</script>

<style lang="scss">
.cart-loading {
  .loading {
    top: 40%;
  }
}
.checkout-steps{
  display:flex;
  justify-content: center;
  margin:40px 0;
  .chk-step{
    cursor: pointer;
    display:flex;
    justify-content: flex-start;
    align-items: center;
    position:relative;
    margin-right:2px;
    .chk-step-number{
      background-color:#fff;
      color:#ccc;
      border:1px solid #ccc;
      border-radius: 100%;
      min-width:25px;
      min-height: 25px;
      text-align: center;
      margin-right:5px;
    }
    .chk-step-name{
      font-weight:600;
      color:#ccc;
      font-size:14px;
    }
    .chk-step-bar{
      min-width:35px;
      height: 2px;
      background-color:#ccc;
      margin-left:2px;
    }
  }
  .completed{
    .chk-step-number{
      background-color:#005488;
      color:#fff;
      border-color: #005488;
    }
    .chk-step-name{
      color:#005488;
    }
    .chk-step-bar{
      background-color:#005488;
    }
  }
}
.sub{
  .cart-flex-item{
    font-weight:500;
    color:#3c3c3c;
  }
  .discount{
    color:green
  }
}
.cart-body{
  padding:50px;
  display:flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 216px);
}
.cart-cont{
  width:650px;
  min-height: max-content;
  border-radius: 7px;
  box-shadow: 0px 0px 5px 5px rgba(0,0,0,.1);
  padding:20px;
  display:flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.cart-col {
  min-height: 50vh;
  width:100%;
  padding:20px;
}
.cart-logo{
  text-align: center;
}
.cart-logo img {
  display:block;
  margin:0 auto;
  width:300px;
}
.cart-form{
  margin:20px 0;
}
.cart-form-row {
  width:100%;
}
.cart-form-label{
  font-size:20px;
  font-weight: 600;
  color:#005488;
  margin-bottom:15px;
}
.cart-input{
  width:100%;
  border:1px solid #ccc;
  border-radius: 7px;
  padding:10px;
  background-color:#f9f9f9f9;
}
.cart-input:focus{
  outline-color:#f08028;
}
.cart-form-input {
  margin-bottom:10px;
}
.cart-flex-row{
  display:flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.cart-flex-item{
  width:32%;

}
.cart-sum .cart-flex-item.cart-item-icon {
  width:10%;
  font-size:14px;
  color:#8bc451;
  text-align: center;
}
.cart-sum .cart-flex-item.cart-item-name {
  width:90%;
}
.cart-sum .cart-flex-item.cart-item-price {
  width:15%;
  font-size:25px;
  font-weight: 900;
}
.cart-sum .cart-flex-item.cart-item-options {
  width:15%;
  font-size:12px;
  cursor:pointer;
}
.cart-sum .cart-form-row {
  padding:5px 0;
  border-bottom:1px solid #ccc;
}
.cart-sum .cart-item-name h3{
  color:#000;
  font-weight:500;
  font-size:16px;
}
.cart-sum .cart-item-name p{
  display:none;
}
.cart-item-options:hover{
  color:#f08028
}
.cart-sum .cart-form-label{
  font-weight: 700;
  font-size:22px;
}
.cart-total-cont{
  width:100%;
  margin-top:20px;
}
.cart-total-cont .cart-form-row {
  border-bottom:none;
  font-weight: 900;
  margin-bottom:0;
}
.cart-total-cont .cart-flex-item:last-child{
  text-align: right;
}
.cart-total {
  border-top:1px solid #ccc;
  padding-top:20px;
  font-size:18px;
}
.complete-payment{
  background-color:#32364e;
  color:#fff;
  font-weight: 700;
  text-align: center;
  padding:10px 20px;
  width:100%;
  border-radius: 7px;
  align-self: flex-start;
  cursor:pointer;
  transition:all .2s ease;
  margin-top:40px;
  line-height: 2;
}
.complete-payment:hover{
  background-color:#1d2346;
}
.resend-code{
  background-color:#32364e;
  color:#fff;
  font-weight: 700;
  text-align: center;
  padding:2px 4px;
  width:150px;
  border-radius: 7px;
  align-self: flex-start;
  cursor:pointer;
  transition:all .2s ease;
  margin-top:10px;
  line-height: 2;
}
.resend-code:hover{
  background-color:#1d2346;
}
.stripe-badge{
  img{
    display:block;
    margin:40px auto 0 auto;
  }
}
.continue-button{
  margin-top:40px;
}
@media (max-width:768px){
  .checkout-steps{
    .chk-step{
      .chk-step-number{
        width:20px;
        height: 20px;
        min-width:20px;
        min-height: 20px;
        margin-right:2px;
        font-size:12px;
      }
      .chk-step-name{
        font-size:12px;
      }
      .chk-step-bar{
        width:15px;
        height: 2px;
      }
    }
  }
  .cart-body{
    padding:10px;
    align-items: flex-start;
  }
  .cart-cont{
    width:90%;
    height: max-content;
    padding:10px;

  }
  .cart-col {
    min-height: 100%;
    width:100%;
    padding:10px;
  }
  .cart-message {
    margin:20px 0 20px 0;
    font-size:12px;
  }
  .cart-form-label{
    font-size:16px;
  }
  .cart-sum .cart-flex-item.cart-item-icon {
    font-size:22px;
    text-align: center;
  }
  .cart-sum .cart-flex-item.cart-item-name {
    padding-left:10px;
  }
  .cart-sum .cart-flex-item.cart-item-price {
    font-size:18px;
    font-weight: 900;
  }
  .cart-sum .cart-flex-item.cart-item-options {
    font-size:14px;
    text-align:center;
  }
  .cart-sum .cart-flex-item.cart-item-options span {
    display:none;
  }
  .cart-sum .cart-item-name h3{
    font-size:14px;
  }
  .cart-sum .cart-item-name p{
    display:none;
  }
  .cart-sum .cart-form-label{
    font-weight: 900;
    font-size:16px;
  }
  .cart-total-cont{
    width:100%;
    margin-top:30px;
  }
  .complete-payment{
    width:100%;
    margin-left:0;
  }
  .stripe-badge{
    img{
      width:100%;
    }
  }
}
@media (max-width:520px){
  .checkout-steps {
    transform:scale(0.9);
  }
}
@media (max-width:470px){
  .checkout-steps {
    transform:scale(0.8);
  }
}
@media (max-width:432px){
  .checkout-steps {
    transform:scale(0.75);
  }
}
@media (max-width:400px){
  .checkout-steps {
    transform:scale(0.7);
  }
}
@media (max-width:378px){
  .checkout-steps {
    transform:scale(0.7);
  }
  .cart-cont{
    box-shadow:none;
  }
}
@media (max-width:340px){
  .cart-body{padding:0;}
  .cart-cont{
    width:100%;
    padding:10px;
  }
  .cart-flex-row{
    justify-content: flex-start;
  }
  .cart-message{
    font-size:16px;
  }
  .cart-sum .cart-flex-item.cart-item-price{
    width:30%;
    font-weight:700;
    font-size:16px;
    text-align:right;
  }
  .cart-total {
    justify-content: space-between;
    .cart-flex-item{
      width:max-content;
    }
  }
  .checkout-steps {
    transform:scale(1);
    justify-content: space-between;
    .chk-step{
      flex-wrap: wrap;
      text-align: center;
      justify-content: center;
      align-items: flex-start;
      width:23%;
    }
    .chk-step-bar{
      display:none;
    }
  }
}
</style>
